<template>
  <v-card>
    <v-toolbar color="primary" dark>
      <v-toolbar-title>
        {{
          lineUp._id || !edit
            ? $t('fields.global.lineUp')
            : $t('titles.global.newAModel', {
                field: $t('fields.global.lineUp'),
              })
        }}
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <v-btn dark icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text>
      <v-layout wrap>
        <v-flex md6 xs12 px-2>
          <user-field
            v-model="lineUp.userId"
            v-validate="'required'"
            :team-id="teamId"
            :readonly="!edit"
            type-role="player"
            :label="$tc('titles.global.player') + ' (*)'"
            :data-vv-name="$tc('titles.global.player')"
            :error-messages="errors.collect($tc('titles.global.player'))"
            @focus="(e) => e.target.click()"
            @changePlayer="onChangePlayer"
          />
        </v-flex>
        <v-flex md3 sm6 xs12 px-2>
          <v-text-field
            v-model="lineUp.dorsal"
            v-validate="'required'"
            :label="$t('fields.global.dorsal') + ' (*)'"
            type="number"
            :loading="loadingUser"
            :readonly="!edit"
            :data-vv-name="$tc('fields.global.dorsal')"
            :error-messages="errors.collect($tc('fields.global.dorsal'))"
          />
        </v-flex>
        <v-flex md6 xs12 px-2>
          <v-autocomplete
            v-model="lineUp.position"
            v-validate="'required'"
            :items="teamPositions"
            :label="$t('fields.global.position') + ' (*)'"
            :loading="loadingUser"
            :readonly="!edit"
            :data-vv-name="$tc('fields.global.position')"
            :error-messages="errors.collect($tc('fields.global.position'))"
            @focus="(e) => e.target.click()"
          />
        </v-flex>
        <v-flex md6 xs12 px-2>
          <v-select
            v-model="lineUp.convocation"
            :items="teamConvocations"
            :readonly="!edit"
            :label="$t('fields.global.convocation')"
            :loading="loadingUser"
            @focus="(e) => e.target.click()"
          />
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-divider />
    <v-card-actions v-if="edit">
      <template>
        <span style="color: red">(*) &nbsp;</span>
        <span>{{ $t('action.messages.fieldRequired') }}</span>
      </template>
      <v-spacer />
      <meta-button type="cancel" @click="cancel" />
      <meta-button
        v-if="!lineUp._id"
        type="create"
        :loading="loading"
        @click="submit"
      />
      <meta-button v-else type="update" :loading="loading" @click="submit" />
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import UserField from '@/components/widgets/Input/UserField'

export default {
  name: 'LineUpForm',
  components: { UserField },
  props: {
    teamId: {
      type: String,
      required: true,
      default: '',
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    edit: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      lineUp: {},
      loadingUser: false,
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({
      teamPositions: 'teams/teamPositions',
      teamConvocations: 'teams/teamConvocations',
    }),
  },
  methods: {
    submit() {
      this.validate().then(
        (valid) => valid && this.$emit('submit', this.lineUp)
      )
    },
    setLineUp(lineUp) {
      this.lineUp = lineUp || {}

      if (this.lineUp.position == 'noPositionSpecified')
        this.lineUp.position = ''
    },
    onChangePlayer(player) {
      let { dorsal, position } = player
      if (dorsal || dorsal === 0) {
        this.lineUp.dorsal = dorsal
      }
      if (position && !this.lineUp.position) this.lineUp.position = position
    },
    clear() {
      this.nextTick(() => {
        this.lineUp = {}
        this.$validator.reset()
      })
    },
    cancel() {
      this.$emit('cancel')
      this.clear()
    },
  },
}
</script>
